export default __webpack_public_path__ + "static/media/highlight.4dca4673.svg";